import * as $ from "jquery";
import {routesObject} from "./polygons-map-routes";

export default class PolygonsMap {
    constructor($block) {
        if (!$block.length) return;

        this.$block = $block;
        this.mapId = this.$block.attr('id');
        this.routesCoordinates = {
            type: 'FeatureCollection',
            features: [
                {
                    type: "Feature",
                    geometry: {
                        type: "LineString",
                        coordinates: [[53.1871, 50.1215], [53.1881, 50.1223], [53.1900, 50.1149], [53.1925, 50.1044], [53.1950, 50.0940], [53.1943, 50.0936], [53.1861, 50.0881], [53.1860, 50.0883], [53.1858, 50.0886], [53.1855, 50.0886], [53.1852, 50.0885], [53.1851, 50.0881], [53.1850, 50.0876], [53.1850, 50.0872], [53.1832, 50.0861], [53.1842, 50.0818], [53.1797, 50.0787], [53.1801, 50.0766], [53.1754, 50.0730], [53.1706, 50.0757], [53.1694, 50.0756], [53.1664, 50.0736], [53.1656, 50.0738], [53.1649, 50.0782], [53.1651, 50.0807], [53.1647, 50.0819], [53.1653, 50.0841], [53.1654, 50.0850], [53.1652, 50.0891], [53.1652, 50.0896], [53.1653, 50.0898], [53.1654, 50.0900], [53.1654, 50.0903], [53.1653, 50.0904], [53.1651, 50.0905], [53.1650, 50.0904], [53.1649, 50.0902], [53.1649, 50.0898], [53.1650, 50.0897], [53.1651, 50.0893], [53.1651, 50.0888], [53.1649, 50.0883], [53.1643, 50.0877], [53.1637, 50.0873], [53.1631, 50.0874], [53.1626, 50.0878], [53.1615, 50.0890], [53.1595, 50.0908], [53.1576, 50.0919], [53.1568, 50.0921], [53.1567, 50.0912], [53.1572, 50.0892], [53.1575, 50.0862], [53.1577, 50.0846], [53.1576, 50.0822], [53.1576, 50.0810], [53.1574, 50.0795], [53.1576, 50.0759], [53.1490, 50.0745], [53.1486, 50.0748], [53.1483, 50.0746], [53.1480, 50.0747], [53.1415, 50.0783], [53.1390, 50.0775], [53.1394, 50.0839]]
                    },
                    options: {
                        strokeColor:'#b43dcc',
                        strokeWidth: 5,
                        dataName:'80'
                    }
                },
                {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [53.1871,50.1216]
                    },
                    properties:{
                        balloonContent: 'Поликлиника (Железнодорожный вокзал)',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconColor:'#b43dcc',
                        iconImageHref: '../img/traffic/minibus_80.svg',
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.1871, 50.1216]
                    },
                    properties:{
                        balloonContent: 'Поликлиника (Железнодорожный вокзал)',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.189716, 50.115960]
                    },
                    properties:{
                        balloonContent: 'Буянова (ул. Красноармейская)',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.191679, 50.107881]
                    },
                    properties:{
                        balloonContent: 'Музей им. П.В. Алабина',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.193133, 50.101860]
                    },
                    properties:{
                        balloonContent: 'Галактионовская (ул. Красноармейская)',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.194388, 50.096606]
                    },
                    properties:{
                        balloonContent: 'Фрунзе',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.194184, 50.093336]
                    },
                    properties:{
                        balloonContent: 'Дом промышленности',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.189884, 50.090470]
                    },
                    properties:{
                        balloonContent: 'Некрасовская (ул. Куйбышева)',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.185108, 50.086949]
                    },
                    properties:{
                        balloonContent: 'пл. Революции',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.183553, 50.084658]
                    },
                    properties:{
                        balloonContent: 'Клуб Дзержинского',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.180289, 50.079130]
                    },
                    properties:{
                        balloonContent: 'пл. Дзержинского',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.179853, 50.076346]
                    },
                    properties:{
                        balloonContent: 'Водников',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [53.177235, 50.074389]
                    },
                    properties:{
                        balloonContent: 'Кутякова',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.167803, 50.074569]
                    },
                    properties:{
                        balloonContent: 'Тракторная',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.165687, 50.073370]
                    },
                    properties:{
                        balloonContent: 'Хлебозавод №3',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.164779, 50.079974]
                    },
                    properties:{
                        balloonContent: 'Дарвина',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.160333, 50.089779]
                    },
                    properties:{
                        balloonContent: ' Ростовский пер.',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.157541, 50.078265]
                    },
                    properties:{
                        balloonContent: 'Аллея 70-летия Победы',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.156718, 50.075549]
                    },
                    properties:{
                        balloonContent: 'Осетинская',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.153240, 50.075013]
                    },
                    properties:{
                        balloonContent: 'Ефрема Медведева',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.149839, 50.074490]
                    },
                    properties:{
                        balloonContent: 'Софийская площадь',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.144339, 50.076584]
                    },
                    properties:{
                        balloonContent: 'Осетинская 2',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.139618, 50.077595]
                    },
                    properties:{
                        balloonContent: 'Александра Солженицына',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                },
                {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates:[53.139318, 50.083675]
                    },
                    properties:{
                        balloonContent: 'Парк дружбы народов',
                    },
                    options:{
                        iconLayout: 'default#image',
                        iconImageHref: "../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg",
                        iconImageSize: [22, 22],
                        iconImageOffset: [-11, -11],
                        dataName:'80'
                    }
                }
            ]
        }

        routesObject.map(route => {
            this.routesCoordinates.features.push(
            {
                type: "Feature",
                    geometry: {
                type: "LineString",
                    coordinates: route.routeCoordinates
            },
                options: {
                    strokeColor: this.getRouteColor(route),
                        strokeWidth: 5,
                        dataName:route.name
                }
            })

            route.routeStops.forEach(stopObject => {
                this.routesCoordinates.features.push(
                    {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: stopObject.stopCoordinates
                        },
                        properties:{
                            balloonContent: stopObject.stopName,
                        },
                        options:{
                            iconLayout: 'default#image',
                            iconImageHref: this.getRouteStopImage(route),
                            iconImageSize: [22, 22],
                            iconImageOffset: [-11, -11],
                            dataName:route.name
                        }
                    }
                )
            })
        })



        try {
            this.map = null;
            this.init();
        } catch (e) {
            console.log(e);
        }
    }

    init() {
        this.initMap(this.mapId).then(map => this.map = map);
    }

    initMap(id) {
        return new Promise(resolve => {
            ymaps.ready(() => {
                 const map = new ymaps.Map(id, {
                    center: [53.151079, 50.075499],
                    controls: ['zoomControl'],
                    zoom: 14
                }, {
                     suppressMapOpenBlock: true,
                     yandexMapDisablePoiInteractivity: true
                });

                map.behaviors.disable('scrollZoom');
                map.behaviors.disable('dblClickZoom');
                map.behaviors.disable('multiTouch');


                window.routeObjects = ymaps.geoQuery(this.routesCoordinates).addToMap(map);

                checkStateRoutes();

                $('.traffic-items-wrapper').on('click', '.number', function (){
                    const $this = $(this);

                    $('.traffic-items-wrapper').find('.number').each((_,number) => {
                        $(number).removeClass('active');
                    });

                    if ($this.hasClass('active')) {
                        $this.removeClass('active');
                    } else {
                        $this.addClass('active');
                    }
                    setTimeout(()=> {
                        checkStateRoutes();
                    }, 10);


                    return false;
                });

                function checkStateRoutes () {
                    let shownObjects,
                        byColor = new ymaps.GeoQueryResult();

                    const colorType = $('.traffic-items-wrapper').find('.number.active').data('number');
                        if (colorType) {

                            byColor = routeObjects.search('options.dataName = "' + colorType + '"').add(byColor);
                        }

                    // Мы отобрали объекты по цвету. Покажем на карте объекты,
                    shownObjects = byColor.addToMap(map);
                    // Объекты, которые не попали в выборку, нужно убрать с карты.
                    routeObjects.remove(shownObjects).removeFromMap(map);
                }


                resolve(map);
            });
        })
    }

    getRouteColor(route){
        switch (route.name){
            case '80':
                return '#b43dcc'

            case '32':
                return '#3db300'

            case '105':
                return '#3db300'

            case '118':
                return '#3db300'

            case '177':
                return '#3db300'

            case '48д':
                return '#ff8a00'

            case '48к':
                return '#ff8a00'

            case '114':
                return '#ff8a00'

            case '128':
                return '#ff8a00'

            case '140':
                return '#ff8a00'
        }
    }

    getRouteStopImage(route){
        switch (route.name){
            case '80':
                return '../../netcat_template/template/Primary/assets/img/traffic/minibus_80.svg'

            case '32':
                return '../../netcat_template/template/Primary/assets/img/traffic/bus.svg'

            case '105':
                return '../../netcat_template/template/Primary/assets/img/traffic/bus.svg'

            case '118':
                return '../../netcat_template/template/Primary/assets/img/traffic/bus.svg'

            case '177':
                return '../../netcat_template/template/Primary/assets/img/traffic/bus.svg'

            case '48д':
                return '../../netcat_template/template/Primary/assets/img/traffic/minibus.svg'

            case '48к':
                return '../../netcat_template/template/Primary/assets/img/traffic/minibus.svg'

            case '114':
                return '../../netcat_template/template/Primary/assets/img/traffic/minibus.svg'

            case '128':
                return '../../netcat_template/template/Primary/assets/img/traffic/minibus.svg'

            case '140':
                return '../../netcat_template/template/Primary/assets/img/traffic/minibus.svg'
        }
    }
}

